import { FC } from "react";
import { FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useBreakPenalty } from "@sinch/components/application/RateInterval/CreateInterval/BreakPenalty/BreakPenaltyProvider";
import { CheckboxInput } from "@sinch/components/form/CheckboxInput/CheckboxInput";
import { useMuiController } from "@sinch/components/index";

/**
 * Whether the penalty is reported under its own component instead of the component of the rate it is valued from
 */
export const PenaltyCustomComponentField: FC = () => {
  const { t } = useTranslation();
  const { path, disabled } = useBreakPenalty();
  const { field } = useMuiController<FieldValues, string>({ name: `${path}.useCustomComponent`, disabled });

  return (
    <CheckboxInput
      {...field}
      checked={field.value}
      helperText={t("RateUnit.breakPenaltyCustomComponentHint")}
      label={t("RateUnit.breakPenaltyCustomComponent")}
    />
  );
};
